import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "./StoryFinishModal.css";

export default function StoryFinishModal({ story, score, total, savedWords, onClose }) {
  const navigate = useNavigate();
  const [animateChecks, setAnimateChecks] = useState(false);

  useEffect(() => {
    // 🎵 Play sound
    const audio = new Audio("/sounds/finishquiz.mp3");
    audio.volume = 0.6;
    audio.play().catch(() => {});

    // ✅ Trigger checkmark animations after short delay
    setTimeout(() => setAnimateChecks(true), 500);

    // 🎊 Trigger confetti
    launchConfetti();

  }, []);

  // 🎊 Lightweight confetti generator
  const launchConfetti = () => {
    const colors = ["var(--color-primary)", "#22c55e", "#facc15", "#ef4444", "#a855f7"];
    for (let i = 0; i < 30; i++) {
      const confetti = document.createElement("div");
      confetti.className = "confetti";
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = Math.random() * 100 + "vw";
      confetti.style.animationDelay = Math.random() * 0.2 + "s";
      confetti.style.width = confetti.style.height = Math.random() * 8 + 6 + "px";
      document.body.appendChild(confetti);

      setTimeout(() => confetti.remove(), 2200);
    }
  };

  return (
    <div className="finish-overlay">
      <div className="finish-modal">
        <button className="finish-close-x" onClick={onClose}>
          ✕
        </button>
  
        <div className="finish-emoji pulse">🎉</div>
        <h2 className="finish-title">Boraaa! Você terminou uma história!</h2>
        <p className="finish-subtitle">
          Isso te trouxe um passo mais perto da fluência! 
        </p>
  
        <ul className="finish-achievements">
          <li className={animateChecks ? "visible" : ""}>
            📖 {story.level} história concluída
          </li>
          <li className={animateChecks ? "visible" : ""}>
            👂 Melhor compreensão
          </li>
          <li className={animateChecks ? "visible" : ""}>
            🧠{" "}
            {savedWords > 0
              ? `${savedWords} novas palavras salvas para fortalecer vocabulário`
              : "Vocabulário fortalecido"}
          </li>
          <li className={animateChecks ? "visible" : ""}>
            📝 Quiz concluído — {score} de {total} corretas
          </li>
        </ul>
  
        <p className="finish-extra">
        🏆 Cada história te faz evoluir!
          <br />
            
        </p>
  
        <button
          className="finish-close-btn"
          onClick={() => {
            onClose();
            navigate("/home");
          }}
        >
          Continuar 🚀
        </button>
      </div>
    </div>
  );  
} 
  
